import { useMutation } from '@tanstack/react-query';
import { usersApi, UpdateProfileDto, ChangePasswordDto } from '../lib/api/users';
import { useAuthStore } from '../store/authStore';

export function useUpdateProfile() {
  const { updateUser } = useAuthStore();

  return useMutation({
    mutationFn: (dto: UpdateProfileDto) => usersApi.updateProfile(dto),
    onSuccess: (user) => {
      updateUser(user);
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (dto: ChangePasswordDto) => usersApi.changePassword(dto),
  });
}

export function useDeleteAccount() {
  const { clearAuth } = useAuthStore();

  return useMutation({
    mutationFn: () => usersApi.deleteAccount(),
    onSuccess: () => {
      clearAuth();
      window.location.href = '/login';
    },
  });
}
